import { __assign, __spreadArray } from "tslib";
import { MenuRoute } from './MenuRoute';
var RouteProvider = /** @class */ (function () {
    /**
     * Creates a route provider which provides a list of flattened routes.
     * @param menuRoutes Routes which appear on the main menu.
     * @param pureRoutes Routes which don't have a menu item.
     * @param notFoundRoute Route to render when the url doesn't match any of the above routes.
     */
    function RouteProvider(menuRoutes, pureRoutes, notFoundRoute) {
        var _a;
        this.menuRoutes = menuRoutes;
        this.pureRoutes = pureRoutes;
        this.notFoundRoute = notFoundRoute;
        this.key = 1;
        this.routeIndex = {};
        this.paramRoutes = [];
        this.flattenedRoutes = [];
        this.flatten(menuRoutes);
        if (pureRoutes)
            this.flatten(pureRoutes);
        /*
        Routes with template parameters must be added last so concrete routes resolve first.
        E.g.
            /clients/subview - SubViewComponent
            /clients/:param - ClientsComponent

        If the above was swapped around, ClientsComponent would match instead of SubViewComponent for /clients/subview.
        */
        (_a = this.flattenedRoutes).push.apply(_a, this.paramRoutes.sortBy("order", "desc").map(function (c) { return c.route; }));
        if (notFoundRoute) {
            this.flattenedRoutes.push({ component: notFoundRoute, key: -1, allowAnonymous: true, routePath: "" });
        }
    }
    /** Gets the path the component is bound to. If the component is bound to multiple paths, the first path is returned. */
    RouteProvider.prototype.getPathForComponent = function (component) {
        var _a;
        return (_a = this.flattenedRoutes.find(function (c) { return c.component === component; })) === null || _a === void 0 ? void 0 : _a.path;
    };
    RouteProvider.prototype.flatten = function (routes, parent) {
        var _a, _b;
        for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
            var route = routes_1[_i];
            var hasComponent = route.path && route.component;
            if (hasComponent) {
                if (parent && !route.breadCrumbParent) {
                    route.breadCrumbParent = parent;
                }
                this.processRoute(route);
            }
            var menuRoute = route;
            var children = __spreadArray(__spreadArray([], ((_a = route.routeChildren) !== null && _a !== void 0 ? _a : []), true), ((_b = menuRoute.children) !== null && _b !== void 0 ? _b : []), true);
            this.flatten(children, (hasComponent && menuRoute.showInBreadCrumb !== false) ? menuRoute : undefined);
        }
    };
    /**
     * Create a copy of the route info, and process it.
     * Adds a unique key, and adds route parameters extracted from the component static params object.
     */
    RouteProvider.prototype.processRoute = function (route) {
        var processed = __assign(__assign({}, route), { routePath: route.path, key: this.key++ });
        var isParamRoute = false;
        if (route instanceof MenuRoute) {
            processed.routePath = route.basePath;
        }
        var viewBaseComponent = route.component;
        if (viewBaseComponent.params) {
            if (processed.routePath.endsWith("/")) {
                processed.routePath = processed.routePath.substring(0, processed.routePath.length - 1);
            }
            for (var param in viewBaseComponent.params) {
                var routeParam = viewBaseComponent.params[param];
                if (!routeParam.isQuery) {
                    isParamRoute = true;
                    processed.routePath += "/:" + param + (routeParam.required ? "" : "?");
                }
            }
        }
        if (!this.routeIndex[processed.routePath]) {
            this.routeIndex[processed.routePath] = true;
            if (isParamRoute) {
                // Must be ordered later by the number of slashes in the path. Root path is a special case.
                this.paramRoutes.push({ route: processed, order: route.path === "/" ? 0 : (route.path.match(/\//g) || []).length });
            }
            else {
                this.flattenedRoutes.push(processed);
            }
        }
    };
    return RouteProvider;
}());
export default RouteProvider;
